import script from "./SociosPrivadoView.vue?vue&type=script&setup=true&lang=js"
export * from "./SociosPrivadoView.vue?vue&type=script&setup=true&lang=js"

import "./SociosPrivadoView.vue?vue&type=style&index=0&id=8efebeca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8efebeca"]])

export default __exports__